import { Component, Input, OnDestroy, OnInit, Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectBundleDO } from '../../../../../../system/system-dtos';
import { EntityGroupDetailsService } from '../../../../../views/entity-group/entity-group-details/entity-group-details.service';
import { arrayIsEmpty, isDefined } from '../../../../../utils/utils';

@Pipe({
  name: 'marketSort',
  standalone: false,
})
export class MarketSortPipe implements PipeTransform {
  transform(data: Array<MarketPricesDO>, marketType: string, numberRows: string): Array<MarketPricesDO> {
    if (arrayIsEmpty(data)) {
      return [];
    }

    if (numberRows === 'one') {
      const filtered = data.filter((marketPrice) => marketPrice.type === marketType);
      if (arrayIsEmpty(data)) {
        return [];
      }
      return [filtered[0]];
    }
    // all
    return data
      .filter((marketPrice) => marketPrice.type === marketType)
      .sort((a: MarketPricesDO, b: MarketPricesDO) => {
        if (isDefined(a.home) && isDefined(a.home.odds) && isDefined(a.home.odds.v)) {
          if (isDefined(b.home) && isDefined(b.home.odds) && isDefined(b.home.odds.v)) {
            return a.home.odds.v - b.home.odds.v;
          }
          return 1;
        }
        return -1;
      });
  }
}

interface OddsDO {
  o: string;
  v: number;
}

interface MoneyLine {
  sportId: string;
  leagueId: string;
  eventId: string;
  source: string;
  period: string;
  home: OddsDO;
  away: OddsDO;
  draw: OddsDO;
  dateCreated: Date;
  dateUpdated: Date;
}

interface MoneyLineByPeriod {
  period: string;
  lines: MoneyLine[];
}

enum MarketType {
  ONE_X_TWO = 'ONE_X_TWO',
  TWO_WAY = 'TWO_WAY',
  MONEY_LINE = 'MONEY_LINE',
  HANDICAP = 'HANDICAP',
  TOTAL = 'TOTAL',
  TEAM_TOTAL = 'TEAM_TOTAL',
  OUTRIGHT_DED_FACT = 'OUTRIGHT_DED_FACT',
  PLACE_DED_FACT = 'PLACE_DED_FACT',
  CORRECT_SCORE = 'CORRECT_SCORE',
  BOTH_TO_SCORE = 'BOTH_TO_SCORE',
  HALF_TIME_FULL_TIME = 'HALF_TIME_FULL_TIME',
  PLACE = 'PLACE',
  OUTRIGHT = 'OUTRIGHT',
  TOURNAMENT_MATCH_UP = 'TOURNAMENT_MATCH_UP',
  ROUND_MATCH_UP = 'ROUND_MATCH_UP',
  TO_QUALIFY = 'TO_QUALIFY',
}

interface OutcomePriceDO {
  name: string;
  odds: OddsDO;
}

interface MarketPricesDO {
  name: string;
  type: MarketType;
  home: OutcomePriceDO;
  away: OutcomePriceDO;
  draw?: OutcomePriceDO;
}

interface EventPricesDO {
  homeTeam: string;
  awayTeam: string;
  homeScore: number;
  awayScore: number;
  playStatus: string;
  markets: MarketPricesDO[];
}

interface PeriodGroupDO {
  eventDate: string;
  name: string;
  eventPrices: EventPricesDO[];
}

interface PeriodPricesDO {
  name: string;
  periodGroup: PeriodGroupDO[];
}

// const data: PeriodPricesDO[] = []
const data: PeriodPricesDO[] = [
  {
    name: 'Today',
    periodGroup: [
      {
        eventDate: '29st Dec 2020',
        name: 'English - Premier league',
        eventPrices: [
          {
            homeTeam: 'Manchester United',
            awayTeam: 'Chelsea',
            homeScore: 3,
            awayScore: 1,
            playStatus: "First Half 32'",
            markets: [
              {
                name: 'Moneyline - Match',
                type: MarketType.MONEY_LINE,
                home: {
                  name: 'Manchester United',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: 'Chelsea',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Handicap - Match (1.0)',
                type: MarketType.HANDICAP,
                home: {
                  name: '+1.0',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: '-1.0',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Handicap - Match (2.0)',
                type: MarketType.HANDICAP,
                home: {
                  name: '+2.0',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: '-2.0',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Total - Match (1.0)',
                type: MarketType.TOTAL,
                home: {
                  name: 'Over',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                away: {
                  name: 'Under',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Total - Match (2.0)',
                type: MarketType.TOTAL,
                home: {
                  name: 'Over',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                away: {
                  name: 'Under',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
            ],
          },
          {
            homeTeam: 'Liverpool',
            awayTeam: 'Fulham',
            homeScore: 1,
            awayScore: 1,
            playStatus: "First Half 31'",
            markets: [
              // {
              //     name: 'Moneyline - Match',
              //     type: MarketType.MONEY_LINE,
              //     home: {
              //         name: "Manchester United",
              //         odds: {
              //             o: "us",
              //             v: 108
              //         }
              //     },
              //     draw: {
              //         name: "Draw",
              //         odds: {
              //             o: "us",
              //             v: 101
              //         }
              //     },
              //     away: {
              //         name: "Chelsea",
              //         odds: {
              //             o: "us",
              //             v: 111
              //         }
              //     }
              //
              // },
              {
                name: 'Handicap - Match (1.0)',
                type: MarketType.HANDICAP,
                home: {
                  name: '+1.0',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: '-1.0',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Handicap - Match (2.0)',
                type: MarketType.HANDICAP,
                home: {
                  name: '+2.0',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: '-2.0',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Total - Match (1.0)',
                type: MarketType.TOTAL,
                home: {
                  name: 'Over',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                away: {
                  name: 'Under',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Total - Match (2.0)',
                type: MarketType.TOTAL,
                home: {
                  name: 'Over',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                away: {
                  name: 'Under',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        eventDate: '29st Dec 2020',
        name: 'French - league 1',
        eventPrices: [
          {
            homeTeam: 'Paris St. Germain',
            awayTeam: 'Monaco',
            homeScore: 2,
            awayScore: 2,
            playStatus: "Second Half 22'",
            markets: [
              {
                name: 'Moneyline - Match',
                type: MarketType.MONEY_LINE,
                home: {
                  name: 'Paris St. Germain',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: 'Monaco',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Handicap - Match (1.0)',
                type: MarketType.HANDICAP,
                home: {
                  name: '+1.0',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: '-1.0',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Handicap - Match (2.0)',
                type: MarketType.HANDICAP,
                home: {
                  name: '+2.0',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                draw: {
                  name: 'Draw',
                  odds: {
                    o: 'us',
                    v: 101,
                  },
                },
                away: {
                  name: '-2.0',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Total - Match (1.0)',
                type: MarketType.TOTAL,
                home: {
                  name: 'Over',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                away: {
                  name: 'Under',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
              {
                name: 'Total - Match (2.0)',
                type: MarketType.TOTAL,
                home: {
                  name: 'Over',
                  odds: {
                    o: 'us',
                    v: 108,
                  },
                },
                away: {
                  name: 'Under',
                  odds: {
                    o: 'us',
                    v: 111,
                  },
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-form-field-market',
  templateUrl: './market-form-field.component.html',
  styleUrls: ['./market-form-field.component.scss'],
  standalone: false,
})
export class MarketFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  selected: SelectBundleDO;

  bundles: SelectBundleDO[] = [];

  bundleData: any;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  bundleId: any;

  hasFormData: boolean = false;

  linesByPeriod: MoneyLineByPeriod[];

  periodPrices: PeriodPricesDO[] = data;

  toggleMap = {};

  constructor(private entityGroupService: EntityGroupDetailsService) {
    super();
  }

  ngOnInit() {}

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnDestroy() {}

  getEnabledFlag(tag: string, name: string) {
    const enabled: boolean = this.toggleMap[tag + name];
    if (isDefined(enabled)) {
      return enabled;
    }
    this.toggleMap[tag + name] = true;
  }

  public toggle(tag: string, name: string) {
    const enabled: boolean = this.toggleMap[tag + name];
    if (isDefined(enabled)) {
      this.toggleMap[tag + name] = !enabled;
    } else {
      this.toggleMap[tag + name] = false;
    }
  }

  hasMoneyLine(event: EventPricesDO): boolean {
    return this.numberMarkets(event.markets, MarketType.MONEY_LINE) > 0;
  }

  hasHandicap(event: EventPricesDO): boolean {
    return this.numberMarkets(event.markets, MarketType.HANDICAP) > 0;
  }

  hasTotals(event: EventPricesDO): boolean {
    return this.numberMarkets(event.markets, MarketType.TOTAL) > 0;
  }

  hasMoreMarkets(event: EventPricesDO): boolean {
    return false;
  }

  private numberMarkets(markets: MarketPricesDO[], marketType: MarketType): number {
    if (arrayIsEmpty(markets)) {
      return 0;
    }
    let count = 0;
    markets.filter((market) => market.type === marketType).forEach((market) => count++);
    return count;
  }
}
